import { useState } from "react";
import { PropTypes } from 'prop-types'
import { Accordion, AccordionTab } from "primereact/accordion";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

function AccordionComp({ title, children, onTabOpen, onVal,className }) {
	const [active, setActive] = useState([0]);
	const [active2, setActive2] = useState([]);

	console.log(onVal)
	return (
		<Accordion className={className && className} multiple expandIcon='d-none' collapseIcon='d-none' activeIndex={onVal ? active2 : active} onTabChange={(e) => onVal ? setActive2(e.index) : setActive(e.index)} onTabOpen={onTabOpen}>
			<AccordionTab
				headerTemplate={
					<div className='accordion-header'>
						<h3 className='accordion-header-title'>{title}</h3>
						<div className='accordion-header-icon'>
							{(onVal ? active2.includes(0) : active.includes(0)) ? 
								<MdKeyboardArrowUp size={24} /> : 
								<MdKeyboardArrowDown size={24} />
							}
						</div>
					</div>
				}
			>
				{children}
			</AccordionTab>
		</Accordion>
	);
}
AccordionComp.propTypes = {
	title: PropTypes.string,
	onTabOpen: PropTypes.func,
	children: PropTypes.node
}
export default AccordionComp;
